import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ProvidersList from "@/guiide/components/common/ProvidersList.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'LowCostDrawdown',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Low Cost Providers", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("p", null, [
      _createTextVNode(" A selection of three large providers which offer drawdown and a choice of investments are shown below. Many others are also available and you can find more information at "),
      _createElementVNode("a", {
        href: "https://www.moneyhelper.org.uk",
        target: "_blank"
      }, "moneyhelper.org.uk"),
      _createTextVNode(". ")
    ], -1)),
    _createVNode(ProvidersList, {
      "show-charges": false,
      title: "Providers"
    })
  ], 64))
}
}

})